import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TaskCheckbox.module.css';

const TaskCheckbox = ({ checked, onChange }) => {
  const { t } = useTranslation();
  const [showFlash, setShowFlash] = useState(false);

  const handleChange = (e) => {
    if (e.target.checked && !checked) {
      setShowFlash(true);
      // Trigger haptic feedback if available
      if (window.navigator && window.navigator.vibrate) {
        window.navigator.vibrate(50);
      }
      setTimeout(() => setShowFlash(false), 400);
    }
    onChange(e);
  };

  return (
    <div className={styles.checkbox}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        onClick={(e) => e.stopPropagation()}
        aria-label={checked
          ? t('records.views.task.item.mark_incomplete_aria')
          : t('records.views.task.item.mark_complete_aria')}
      />
      <div className={`${styles.visual} ${showFlash ? styles.successFlash : ''}`}>
        <svg viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
    </div>
  );
};

export default TaskCheckbox;
